import React from "react";
import ImgPhone from '../images/clic.png'
import ImgVisibilite from '../images/visibilite.png'
import ImgReseau from '../images/reseau.png'
import ImgTamp from '../images/tamp-sign.png'
import ImgPhoneMockup from '../images/phone-mockup.png'

function Card({ children, className = "" }) {
  return (
    <div
      className={
        "rounded-[22px] overflow-hidden sm:rounded-3xl bg-[#F2F2F2] shadow-[0_2px_12px_rgba(0,0,0,0.06)] p-6 sm:p-7 md:p-8 " +
        className
      }
    >
      {children}
    </div>
  );
}

function Card2({ children, className = "" }) {
  return (
    <div
      className={
        "rounded-[22px] overflow-hidden sm:rounded-3xl bg-[#F2F2F2] shadow-[0_2px_12px_rgba(0,0,0,0.06)]  " +
        className
      }
    >
      {children}
    </div>
  );
}


export default function PourquoiPactePartenaires() {
  return (
    <section
      id="pourquoipacte"
      className="relative mx-auto max-w-[1519px] px-4 sm:px-6 lg:px-8 py-10 sm:py-14 lg:py-16"
    >
      <h2 className="text-3xl sm:text-4xl font-asap font-semibold tracking-tight mb-6 sm:mb-8">
        Pourquoi devenir partenaire ?
      </h2>
      <div
        aria-hidden
        className="pointer-events-none absolute -right-36 top-[55%] translate-y-[-50%] hidden md:block"
      >
        <img src={ImgTamp} alt="" className="h-[600px]" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-[60%_40%] gap-6 lg:gap-7 mb-6">
        <Card>
          <h3 className="text-lg font-asap sm:text-2xl font-semibold mb-2">
            Plus de visibilité locale
          </h3>
          <p className="text-sm sm:text-base text-neutral-700">
            L’application met en avant votre commerce auprès des habitants de Claix
            grâce <br />à une communication moderne.
          </p>
          <div className="relative mt-6 h-[220px] sm:h-[260px] md:h-[300px]">
            <img
              src={ImgVisibilite}
              alt="Aperçu offres locales"
              className="absolute -bottom-8"
            />
          </div>
        </Card>
        <Card className="relative overflow-hidden">
          <h3 className="text-lg font-asap sm:text-2xl font-semibold mb-2">
            Publiez vos offres en un clic
          </h3>
          <p className="text-sm sm:text-base text-neutral-700">
            Faites connaître vos promotions, nouveautés ou événements directement
            depuis l’app, en toute simplicité.
          </p>
          <div className="relative mt-6 h-[220px] sm:h-[260px] md:h-[300px]">
            <img
              src={ImgPhone}
              alt="Aperçu offres locales"
              className="absolute -bottom-8"
            />
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-[40%_60%] gap-6 lg:gap-7">
        <Card2>
          <div className="p-6 sm:p-7 md:p-8">
            <h3 className="text-lg font-asap sm:text-2xl font-semibold mb-2">
              Fidélisez vos clients
            </h3>
            <p className="text-sm sm:text-base text-neutral-700">
              Offrez une carte de fidélité 100% digitale. Simple, pratique et
              toujours dans la poche de vos clients.
            </p>
          </div>
          <div className="relative mt-6 h-[220px] sm:h-[260px] md:h-[300px]">
            <img
              src={ImgPhoneMockup}
              alt="Aperçu offres locales"
              className="absolute -bottom-8 "
            />
          </div>
        </Card2>

        <Card className="relative">
          <h3 className="text-lg font-asap sm:text-2xl font-semibold mb-2">
            Un réseau qui vous soutient
          </h3>
          <p className="text-sm sm:text-base text-neutral-700">
            Rejoignez une dynamique collective avec les autres commerçants,
            bénéficiez d’une communication commune. <br/>
          </p>
           <div className="relative mt-6 h-[220px] sm:h-[260px] md:h-[300px]">
            <img
              src={ImgReseau}
              alt="Aperçu offres locales"
              className="absolute -bottom-8"
            />
          </div>
        </Card>
      </div>
    </section>
  );
}